export default {
	title: 'Configuración de Herramientas de Análisis',
	subtitle: 'Configurar y gestionar herramientas de análisis de gráficos',
	actions: {
		add: 'Añadir Herramienta',
		edit: 'Editar',
		delete: 'Eliminar',
		save: 'Guardar',
		cancel: 'Cancelar',
		confirm: 'Confirmar',
		clear: 'Limpiar',
		addNow: 'Añadir Ahora'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar esta herramienta?',
		deleteSuccess: 'Eliminado exitosamente',
		saveSuccess: 'Guardado exitosamente',
		updateSuccess: 'Actualizado exitosamente',
		selectDeleteWarning: 'Por favor seleccione los registros a eliminar',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
		nameLengthRange: 'La longitud del nombre de configuración debe estar entre 1-50 caracteres',
		atLeastOneTool: 'Por favor seleccione al menos una herramienta',
		clearedAllSelections: 'Todas las selecciones han sido limpiadas',
		confirmClearSelections: '¿Está seguro de que desea limpiar todas las herramientas seleccionadas?'
	},
	labels: {
		basicInfo: 'Información Básica',
		name: 'Nombre',
		remark: 'Descripción',
		selectedTools: 'Herramientas Seleccionadas',
		availableTools: 'Herramientas Disponibles',
		noSelectedTools: 'No hay herramientas configuradas',
		noConfiguredTools: 'No hay herramientas configuradas',
		configName: 'Nombre de Configuración',
		configDescription: 'Descripción de Configuración'
	},
	placeholder: {
		name: 'Por favor ingrese el nombre de configuración',
		remark: 'Por favor ingrese la descripción de configuración',
		configName: 'Por favor ingrese el nombre de configuración'
	},
	status: {
		loading: 'Cargando datos...',
		noDataTitle: 'Sin Configuración de Herramientas',
		noDataDesc: 'Aún no ha configurado ninguna herramienta de análisis. Haga clic en el botón "Añadir Herramienta" arriba para comenzar a configurar',
		saving: 'Guardando...'
	},
	dialog: {
		editTitle: 'Editar Herramienta',
		addTitle: 'Añadir Herramienta',
		deleteConfirmTitle: 'Confirmación de Eliminación'
	}
}
